import {useState} from 'react'
import {loadHubspotChat} from './scripts'

export const useHubspotChatLauncher = () => {
  const [hasTriggeredLoading, setHasTriggeredLoading] = useState(false)
  const [hasClicked, setHasClicked] = useState(false)
  const [hasLoaded, setHasLoaded] = useState(false)

  const handleHover = () => {
    if (hasTriggeredLoading) return

    loadHubspotChat()
    setHasTriggeredLoading(true)
  }

  const handleClick = ({removeLauncherBtn}: {removeLauncherBtn?: boolean} = {}) => {
    setHasClicked(true)

    let timeout: NodeJS.Timeout | undefined
    const status = window.HubSpotConversations?.widget?.status()

    if (status?.loaded) {
      setHasLoaded(true)
      window.HubSpotConversations?.widget?.open()

      clearTimeout(timeout)

      if (!removeLauncherBtn) return
      document.querySelector('#hubspot-launcher')?.remove()
    } else {
      timeout = setTimeout(() => handleClick({removeLauncherBtn}), 50)
    }
  }

  return {
    hasTriggeredLoading,
    hasClicked,
    hasLoaded,
    handleHover,
    handleClick
  }
}
